import dayjs from 'dayjs';

import { Stack, Text } from '@mantine/core';

type ConfirmRevertProps = {
  originalDate: string;
};

export default function ConfirmRevert({ originalDate }: ConfirmRevertProps) {
  return (
    <Stack>
      <Text>
        Are you sure you want to undo the updates set on{' '}
        <Text span variant="body-sm-bold">
          {dayjs(originalDate).format('MMMM D, YYYY')}
        </Text>
        ? This will reset the price to what it was before all bulk price updates.
      </Text>
    </Stack>
  );
}
